<template>
    <div class="">
        <div class="modal fade" id="loginMoblizer" tabindex="-1" role="dialog" aria-labelledby="loginMoblizerLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body login-mobilizer text-left p-4">
                        <div class="login-mobilizer-inner p-5">
                            <img class="logo mb-3" src="/banks/NBP_FUND.png" alt="" />
                            <div class="moblizer-account-login">
                                <span class="title mb-2"> Your <span class="highlight-color">OTP</span> will be send to your mobile number </span>
                                <div class="form-group mb-2">
                                    <input v-model="form.companyWalletID" readonly type="text" class="form-control" name="companyWalletID" :class="{ 'is-invalid': form.errors.has('companyWalletID') }" />
                                    <has-error :form="form" field="companyWalletID"></has-error>
                                </div>
                                <span class="title mb-2"> Click generate button to proceed? </span>
                                <div class="row normal-ib-space">
                                    <div class="col"> <button class="btn btn-primary" data-dismiss="modal" aria-label="Close"> Cancel </button> </div>
                                    <div class="col"> <button class="btn btn-primary proceed active" @click="generatePin"> Generate </button> </div>
                                </div>
                            </div>
                            <div class="moblizer-account-detail hide">
                                <label class="label block-label"> Please enter the OTP </label>
                                <div class="form-group mb-2">
                                    <input v-model="processForm.pin_code" type="number" class="form-control" />
                                </div>
                                <div class="row normal-ib-space mt-3">
                                    <div class="col"> <button class="btn btn-primary" data-dismiss="modal" aria-label="Close" @click="cancelMobilizer"> Cancel </button> </div>
                                    <div class="col"> <button :disabled="processForm.busy" class="btn btn-primary active" @click="proceedLogin"> Proceed </button> </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>

    export default {
        props: ['paymentType','payroll_id','payrollTotalAmount','numberOfBeneficiaries'],

        data() {
            return {
                form: new Form({
                    companyWalletID     : '',
                    payrollTotalAmount  : this.payrollTotalAmount,
                    numberOfBeneficiaries: this.numberOfBeneficiaries,
                    payroll_id          : this.payroll_id,
                }),
                processForm : new Form({
                    companyWalletID   : '',
                    pin_code    : '',
                    payroll_id  : this.payroll_id,
                    paymentReprocess : false
                }),
            };
        },
        mounted() {
            setTimeout(() => {
	            this.form.payrollTotalAmount = this.payrollTotalAmount;
                this.form.numberOfBeneficiaries = this.numberOfBeneficiaries;
     	    },2000);
            this.getCompanyAccountNo();
            // EventBus.$on('paymentReprocess', data => {
            //    this.processForm.paymentReprocess = data;
            // });
        },
        methods:{
            getCompanyAccountNo(){
                this.$Progress.start();
                axios.get('/api/getCompanyAccountNo')
                    .then(res => {
                        if(res.status == 200){
                            this.form.companyWalletID = res.data.company.walletID;
                            this.processForm.companyWalletID = res.data.company.walletID;
                            this.$Progress.finish();
                        }else{
                            this.$Progress.fail();
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        this.$Progress.fail();
                        this.showAlertBox('error','System is not responding! Please try again later.');
                    });
            },
            generatePin: function(){
                this.$Progress.start();
                this.form.post('/api/generatePinCode')
                    .then(res => {
                        if(res.status == 200){
                            this.$Progress.finish();
                            if(res.data.status == 200){
                                this.showToastBox('success','Please proceed your batch.');

                                $('#loginMoblizer').find('.moblizer-account-login').addClass('hide');
                                $('#loginMoblizer').find('.moblizer-account-detail').removeClass('hide');
                            }else{
                                this.showToastBox('error',res.data.msg);
                            }
                        }else{
                            this.$Progress.fail();
                            this.showToastBox('error','Some problem in your form data');
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showToastBox('error','Some problem in your form data');
                    });
            },
            proceedLogin: function(){
                this.$Progress.start();
                this.processForm.post('/api/verifyPinCode')
                    .then(res => {
                        if(res.data.status == 200){
                            this.$Progress.finish();
                            this.processPayments();
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Some problem in your form data');
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                    });
            },
            processPayments: function(){
                this.$Progress.start();
                var url = '';
                if(this.paymentType == 'employee_payment'){
                    url = '/api/proceedBatchQueue';
                }else{
                    url = '/api/VendorSendForPayment';
                }
                this.processForm.post(url)
                    .then(res => {
                        if(res.status == 200){
                            this.$Progress.finish();
                            this.showToastBox('success',res.data.message);
                            $('#loginMoblizer').modal('hide');
                            if(this.paymentType == 'employee_payment'){
                                this.$router.push('/employeePayments');
                            }else{
                                this.$router.push('/vendorPayment');
                            }
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Some problem in your form data');
                        }

                    })
                    .catch(err => {
                        console.log(err);
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                    });
            },
            cancelMobilizer: function(){
                $('#loginMoblizer').find('.moblizer-account-login').removeClass('hide');
                $('#loginMoblizer').find('.moblizer-account-detail').addClass('hide');
            },
        },
        destroyed: function() {
            // EventBus.$off('paymentReprocess');
        }

    }
</script>
